import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import feeCalculatorTotal from './feeCalculatorTotal.selector';

const feeCalculatorTotalSel = state => feeCalculatorTotal(state);

const selector = createSelector(
  [feeCalculatorTotalSel],
  (_cashTotal) => {
    const cashTotal = Number(_cashTotal);

    // If cash total is less than or equal to 100.00
    // then just add 2.50 to the total
    if (cashTotal <= 100) {
      return precise(cashTotal + 2.75);
    }

    // Otherwise, take 2.5% of the total and add that to the total
    return precise(((3.00 / 100) * cashTotal) + cashTotal);
  },
);

export default selector;
